import {createContext, type ReactNode, use} from 'react'

type ActivityPanelContextValue = {
  closePanel: () => void
  open: boolean
  openPanel: () => void
  panelTarget: HTMLElement | null
}

export const ActivityPanelContext = createContext<ActivityPanelContextValue | null>(null)

export function useActivityPanel() {
  const context = use(ActivityPanelContext)
  if (!context) throw new Error('useActivityPanel must be used within an ActivityPanelContext')
  return context
}

export function ActivityPanelProvider({children, value}: {children: ReactNode; value: ActivityPanelContextValue}) {
  return <ActivityPanelContext value={value}>{children}</ActivityPanelContext>
}
